// extracted by mini-css-extract-plugin
module.exports = {"name":"_2dsH2UIuxoxsnfpj_KG8Zv","cfo":"_1jXehJV54CfQrTjae928oD","cardContainer":"_1W1kR52JpGjpawl1YDHjiB","round":"_1dnD_RZcaTgogEm6fiTHGN"};